<template>
  <tile class="opc-zpa">
    <foldable v-model="isExpanded" :title="title">
      <div slot="head" class="opc-zm-base-card__head">
        <div class="opc-zm-base-card__head-left">
          <img :src="logo" class="opc-zm-base-card__logo" :alt="title + ' Icon'" tabindex="-1" />
        </div>
        <div class="opc-zm-base-card__head-right">
          <h1 class="opc-zm-base-card__name text-capitalize" :class="{
            'opc-zm-base-card__name-collapse': !isExpanded
          }">
            {{ title }}
            <i class="zm-icon-success main-icon" aria-hidden="true"></i>
          </h1>
          <div v-if="!isExpanded" slot="collapse" class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset">
            <div v-for="selectedPlansLabel in selectedPlansLabelList" :key="selectedPlansLabel">
              {{ selectedPlansLabel }}
            </div>
          </div>
        </div>
      </div>
      <div class="divide-line"></div>
      <div class="opc-zpa__main">
        <p class="opc-zpa__desc">
          {{ $t('billing.pbx.additional_phone_numbers_config.local_and_tf_desc') }}
        </p>
        <config-section :show-head="!!numberSelectValue.length" :show-action="showAdditionalActionRow">
          <span slot="title">{{ $t('billing.pbx.additional_numbers') }}</span>
          <span slot="description">
            {{ $t('billing.pbx.additional_numbers_desc') }}
          </span>
          <number-select
            ref="tollfreeSelect"
            :data-tracking="dataTrackingNumbers"
            :optionList="computedAdditionalOptionList"
            :title="$t('billing.pbx.additional_numbers')"
            v-model="numberSelectValue"
          />
          <zm-tooltip
            v-model='additionalNumbersToolTip'
            slot="action"
            placement="top"
            :disabled="numberSelectValue.length > 0"
            :content="$t('billing.pbx.add_additional_numbers_tips')"
          >
            <zm-button data-testid="checkout-button-237" type="link" @click="addAdditionalNumbers">
              {{ $t('billing.pbx.add_additional_numbers') }}
            </zm-button>
          </zm-tooltip>
        </config-section>
        <div class="opc-zm-base-card__main__footer">
          <div class='opc-zm-base-card__btn--wrap'>
            <zm-button data-testid="checkout-button-238" :disabled='disabledRemove' type='link' ghost @click='removePlanByKey'
                      :aria-label="'remove ' + title + ' plan'">{{ $t('billing.common.remove') }}
            </zm-button>
          </div>
        </div>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import logo from '@/assets/plans/zoom_phone_additional.svg'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import plansMixin from '@/plans/mx/plan';
import dataMixin from './data';
import ConfigSection from '@/plans/ZOOM_PHONE/component/config-section.vue';
import NumberSelect from '@/plans/ZOOM_PHONE/component/select-number-list.vue';
import mxEdit from '@/plans/ZOOM_PHONE/config/mx-edit';
import { PBX_REGIONS } from '@/plans/ZOOM_PHONE/helper/constants';

export default {
  data() {
    return {
      logo,
      title: this.$t('billing.pbx.additional_phone_numbers'),
      isExpanded: true,

      activeRegionKey: PBX_REGIONS.US_AND_CANADA,
      defaultAdditionalType: PBX_SUB_TYPES.PHONE_NUMBER,
    };
  },
  mixins: [plansMixin, dataMixin, mxEdit],
  components: {
    Foldable,
    Tile,
    ConfigSection,
    NumberSelect,
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters({
      'getSelectedPlans': 'getSelectedPlans',
      'getUserCurrentSubscriptions': 'getUserCurrentSubscriptions',
      'plancodeMapSubscriptionDisabled': 'plancodeMapSubscriptionDisabled',
      'boughtPlans': 'boughtPlans',
      'basicConfig': 'basicConfig',
    }),
    computedAdditionalOptionList() {
      return this.mapSelectOptions(this.data_mx_allPlans, this.data_mx_currentBillingCycle);
    },

    showAdditionalActionRow() {
      return this.numberSelectValue.length < this.data_mx_cycleMap[this.data_mx_currentBillingCycle].length;
    },
    numberSelectValue: {
      get() {
        const _map = (plans) =>
          plans.map((x) => ({
            id: x.plan_code,
            number: x.cartInfo?.selected_number ?? 0,
          }));
        
        return _map(this.data_mx_selectedPlans);
      },
      set(val) {
        this.numberSelectValueSetter(val)
      }
    },
    disabledRemove() {
      return (
        (this.data_mx_boughtPlans.length && this.basicConfig?.isDirectSales) || 
        this.data_mx_boughtPlans.find(p => (
          this.plancodeMapSubscriptionDisabled[p.plan_code] ||
          p.isDisablePlanChangeOnline ||
          p.ratePlans?.length > 1
        ))
      );
    }
  },
  created() {
    this.$init();
  },
  methods: {
    ...mapActions([ 'switchSelectPlan']),
    ...mapMutations({
      updateSelectPlan: 'updateSelectPlan',
      removePlan: 'removePlan'
    }),
    $init() {
      if (this.data_mx_selectedPlans.length) return;
      const cyclePlans = this.data_mx_cycleMap[this.data_mx_currentBillingCycle];
      // Add a default number in shopping cart.
      const dfPlan = cyclePlans.find(p => p.sub_type === this.defaultAdditionalType);
      dfPlan && this.updateSelectPlan({
        plan_code: dfPlan.plan_code,
        cartInfo: { selected_number: 1 },
      });
    },
    numberSelectValueSetter(val) {
      this.data_mx_selectedPlans.forEach(p => this.removePlan(p.plan_code));
      (val || []).forEach(p => {
        this.updateSelectPlan({
          plan_code: p.id,
          cartInfo: { selected_number: p.number }
        });
      });
      if (!val.length) {
        this.removePlanByKey();
      }
    },
    switchBillingCycle(v) {
      const cyclePlans = this.data_mx_cycleMap[v];
      if (!this.data_mx_selectedPlans.length) {
        // Add a default number in shopping cart.
        const dfPlan = cyclePlans.find(p => p.sub_type === this.defaultAdditionalType);
        dfPlan && this.updateSelectPlan({
          plan_code: dfPlan.plan_code,
          cartInfo: { selected_number: 1 },
        });
      } else {
        this.data_mx_selectedPlans.forEach(p => {
          const nextPlan = cyclePlans.find(np => np.sub_type === p.sub_type);
          if (!nextPlan) return;
          if (p.plan_code === nextPlan.plan_code) return;
          this.switchSelectPlan([p.plan_code, nextPlan.plan_code, p.cartInfo])
        });
      }
    },
    addAdditionalNumbers() {
      this.$refs.tollfreeSelect.newItem();
    }
  },
  watch: {
    isExpanded: {
      handler(val) {
        this.$tracking.buyInteraction(
          'product details accordion',
          `${this.title}  - ${val ? 'expand' : 'collapse'}`,
        );
      },
    },
    data_mx_currentBillingCycle(v, ov) {
      if (v !== ov) {
        this.switchBillingCycle(v);
      }
    },
  },
};
</script>
  
<style lang="scss">
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-zpa {
  .opc-zm-base-card {
    @include media(mobile) {
      &__name-collapse {
        display: block;
        padding-right: 70px;

        .main-icon {
          transform: translateY(-2px);
        }
      }
    }



  }

  .main-icon {
    color: $theme-color;
  }

  &__main {
    margin-top: 18px;
    border-top: none;
  }

  &__name {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    color: #00053D;
    display: flex;
    flex-direction: row;
    align-items: center;

    .zm-icon-success {
      font-size: 16px;
      margin-left: 12px;
    }
  }

  &__desc {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 450;
    font-size: 14px;
    line-height: 150%;
    color: #00053D;
    margin-bottom: 16px;
  }

  @include media(tablet, desktop) {
    &__unit {
      margin-left: 8px;
    }
  }

  @include media(mobile) {
    .zm-form-item.horizontal-form-item {
      .zm-form-item__content {
        display: flex;
      }
    }

    &__unit {
      margin-left: 8px;

      &--license {
        color: #00053D;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%; /* 16.8px */

        &:first-letter {
          text-transform: capitalize;
        }
      }

      &--price-unit {
        color: #666487;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%; /* 14.4px */
      }
    }
  }

  .opc-pbx__desc {

    ul,
    li {
      list-style: none;
    }

    li {
      font-family: 'Almaden Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 120%;
      color: #00031F;
    }
  }
}

.divide-line {
  width: 100%;
  border-top: 1px solid #dfe3e8;
  margin: 24px 0;
}
</style>
